export default "__VITE_ASSET__BShB1Qj6__"